<template>
  <v-container class="pa-16">
    <v-toolbar flat>
      <v-toolbar-title id="toolbar-title"
        >Tableau croisé dynamique</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <div style="display: flex; align-items: center;">
        <Button
          action_name="Exporter"
          class="mr-2"
          color="primary"
          text
          @clicked="showExportDialog = true"
        >
          <template v-slot:button-content>
            <v-img :src="require('@/assets/export.svg')" alt="humberger" />
          </template>
        </Button>
        <AutoComplete
          id="vue"
          v-model="vue"
          :items="vues"
          item-text="name"
          item-value="name"
          placeholder="Vue"
          class="mt-7"
          @change="getViewByName"
        />
        <Button
          action_name="Sauvegarder vue"
          class="ml-2"
          color="primary"
          text
          @clicked="showAddViewDialog = true"
        />
      </div>
      <v-dialog v-model="showExportDialog" max-width="500px">
        <v-card>
          <v-card-title class="justify-space-between">
            <span class="headline">Choisissez la forme d'export</span>
            <v-btn color="black" dark icon right @click="closeExportDialog">
              <v-icon color="#B2BBAB">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-actions class="btn-actions">
            <Button
              action_name="Excel"
              color="primary"
              text
              :loading="loadingExport"
              @clicked="handleExportClicked"
            />
            <Button
              action_name="Vue"
              color="primary"
              text
              @clicked="exportHTML"
            />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showAddViewDialog" max-width="500px">
        <v-card>
          <v-card-title class="justify-space-between">
            <span class="headline">Ajouter une nouvelle vue</span>
            <v-btn color="black" dark icon right @click="closeViewDialog">
              <v-icon color="#B2BBAB">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-form ref="form" style="width: 100%" v-model="isValid">
                  <v-col class="pa-0" cols="12" md="12" sm="6">
                    <text-input
                      v-model="newViewName"
                      label="Nom de la vue*"
                      id="name"
                      :rules="requiredRules"
                    />
                  </v-col>
                </v-form>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="btn-actions">
            <Button
              action_name="Ajouter"
              color="#11887E"
              text
              :loading="loadingAdd"
              @clicked="addView"
            />
            <Button
              action_name="Annuler"
              color="#B2BBAB"
              text
              @clicked="closeViewDialog"
            />
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="filterDialog" max-width="836px">
        <v-card>
          <v-card-title class="justify-space-between">
            <span class="headline">Filtre</span>
            <v-btn color="black" dark icon right @click="close">
              <v-icon color="#B2BBAB">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6" sm="6" class="ma-0 pt-0 pb-0">
                  <AutoComplete
                    id="clients"
                    v-model="editedItem.clients"
                    :items="clients"
                    label="Client"
                    item-text="name"
                    item-value="id"
                    multiple
                    deletable-chips
                    small-chips
                    return-object
                    @change="getDossiers"
                  />
                </v-col>
                <v-col cols="12" md="6" sm="6" class="ma-0 pt-0 pb-0">
                  <AutoComplete
                    id="dossiers"
                    v-model="editedItem.dossiers"
                    :items="dossiers"
                    label="Projet"
                    item-text="name"
                    item-value="id"
                    multiple
                    deletable-chips
                    return-object
                    small-chips
                    @change="getAgents"
                  />
                </v-col>
                <v-col cols="12" md="6" sm="6" class="ma-0 pt-0 pb-0">
                  <AutoComplete
                    id="agents"
                    v-model="editedItem.agents"
                    :items="agents"
                    label="Agent"
                    item-text="name"
                    item-value="id"
                    return-object
                    multiple
                    deletable-chips
                    small-chips
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pb-6">
            <Button
              action_name="Filtrer"
              color="#86CC26"
              @clicked="save"
              style="width: 220px"
              class="ml-5 mr-5"
              :loading="loading"
            />
            <span style="color:#B2BBAB" @click="handleReset"
              >Réinitialiser</span
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <template v-slot:extension>
        <div class="filter-block">
          <div>
            <template v-for="(client, index) in editedItem.clients">
              <v-chip
                class="ma-1"
                :key="client.name"
                close
                @click:close="handleChipDelete(index, 'clients')"
                >Client:{{ client.name }}</v-chip
              >
            </template>
            <template v-for="(dossier, index) in editedItem.dossiers">
              <v-chip
                class="ma-1"
                :key="dossier.name"
                close
                @click:close="handleChipDelete(index, 'dossiers')"
                >Projet:{{ dossier.name }}</v-chip
              >
            </template>
            <template v-for="(agent, index) in editedItem.agents">
              <v-chip
                class="ma-1"
                :key="agent.name"
                close
                @click:close="handleChipDelete(index, 'agents')"
                >Agent:{{ agent.name }}</v-chip
              >
            </template>
          </div>
          <div>
            <v-chip class="chip-delete">
              <v-icon @click="filterDialog = true" outlined>
                mdi-filter
              </v-icon>
            </v-chip>
          </div>
        </div>
      </template>
    </v-toolbar>

    <v-row justify="center" class="mt-2">
      <v-col cols="3">
        <AutoComplete
          id="rows"
          v-model="editedItem.rows"
          :items="rows"
          item-text="name"
          item-value="id"
          multiple
          deletable-chips
          small-chips
          placeholder="Lignes"
          @change="diplayTable"
        />
      </v-col>
      <v-col cols="3">
        <AutoComplete
          id="year"
          v-model="editedItem.year"
          :items="years"
          item-text="name"
          placeholder="Année"
          @change="diplayTable"
        />
      </v-col>
      <v-col cols="3">
        <AutoComplete
          id="months"
          v-model="editedItem.months"
          :items="computedMonths"
          item-text="name"
          item-value="id"
          multiple
          deletable-chips
          small-chips
          placeholder="Mois"
          @change="handleMonthChange"
        />
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-5">
      <div style="width: 100%; overflow: auto; max-height: 550px;">
        <div v-if="loader" class="pa-4">
          <v-skeleton-loader
            type="table"
            class="mx-auto"
            :loading="loader"
          ></v-skeleton-loader>
        </div>
        <div v-else v-html="tableHtml"></div>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { AutoComplete, Button, TextInput } from "@/components/base";
import months from "@/assets/data/months.json";
import {
  getDynamicPivotTable,
  addViewApi,
  getViewsApi,
  getViewByNameApi,
  exportDynamicPivotTable,
} from "@/services/crosstab.api";
import { getYears } from "@/services/timesheet.api";
import { getActiveUsers } from "@/services/getActiveUsers.api";
import { getCurrentClients } from "@/services/clients.api";
import {
  getDossiersByClients,
  getCurrentDossiersApi,
} from "@/services/dossiers.api";
import { getAgentsByDossiers } from "@/services/users.api";

export default {
  components: { AutoComplete, Button, TextInput },
  data: () => ({
    editedItem: {
      months: [],
    },
    rows: [
      { id: "client", name: "Client" },
      { id: "dossier", name: "Projet" },
      { id: "agent", name: "Agent" },
      { id: "operationType", name: "Type d'opération" },
    ],
    tableHtml: "",
    years: [],
    months: months,
    filterDialog: false,
    agents: [],
    clients: [],
    dossiers: [],
    loading: false,
    vues: [],
    vue: "",
    newViewName: "",
    showAddViewDialog: false,
    isValid: true,
    loadingAdd: false,
    loadingExport: false,
    showExportDialog: false,
    loader:false,
  }),
  created() {
    this.initialize();
  },
  computed: {
    computedMonths() {
      return [{ id: "all", name: "Tous" }, ...this.months];
    },
  },
  methods: {
    handleMonthChange(selected) {
      const allId = "all";
      const allMonthIds = this.months.map((m) => m.id);

      if (selected.includes(allId) && selected.length === 1) {
        this.editedItem.months = [allId, ...allMonthIds];
        return;
      }

      if (selected.includes(allId) && selected.length < allMonthIds.length + 1) {

        this.editedItem.months = selected.filter((id) => id !== allId);
        return;
      }

      if (!selected.includes(allId) && selected.length === allMonthIds.length) {
        this.editedItem.months = [allId, ...selected];
        return;
      }
      this.editedItem.months = selected;
    },
    diplayTable() {
      const months = this.editedItem.months?.filter(m => m !== "all")?.sort((a, b) => a - b);
      const year = this.editedItem.year;

      if (!year || !months || months.length === 0) return;

      const startMonth = `${year}-${months[0].toString().padStart(2, "0")}-01`;
      const lastMonth = new Date(year, months[months.length - 1], 0);
      const endMonth = `${year}-${months[months.length - 1].toString().padStart(2, "0")}-${lastMonth.getDate()}`;

      const payload = {
        ...this.editedItem,
        startMonth,
        endMonth,
        months,
        clients: this.editedItem.clients?.map((client) => client.id),
        dossiers: this.editedItem.dossiers?.map((dossier) => dossier.id),
        agents: this.editedItem.agents?.map((agent) => agent.id),
      };
      this.loader=true;
      getDynamicPivotTable(payload).then((response) => {
        this.tableHtml = response.data;
        this.loader=false;
      });

      this.getClients();
      this.getCurrentDossiers();
    },
    getClients() {
      getCurrentClients({
        year: this.editedItem.year,
        months: this.editedItem.months?.sort((a, b) => a - b),
      }).then((response) => {
        this.clients = response.data;
      });
    },
    getCurrentDossiers() {
      getCurrentDossiersApi({
        year: this.editedItem.year,
        months: this.editedItem.months?.sort((a, b) => a - b),
      }).then((response) => {
        this.dossiers = response.data;
      });
    },
    getDossiers() {
      getDossiersByClients({
        year: this.editedItem.year,
        months: this.editedItem.months?.sort((a, b) => a - b),
        clients: this.editedItem.clients?.map((client) => client.id),
      }).then((response) => {
        this.dossiers = response.data;
      });
    },
    getAgents() {
      getAgentsByDossiers({
        dossiers: this.editedItem.dossiers?.map((dossier) => dossier.id),
      }).then((response) => {
        this.agents = response.data;
      });
    },
    initialize() {
      this.loader = true;
      this.diplayTable();
      const promises = [
        getYears().then((response) => {
          this.years = response.data.years;
        }),
        getActiveUsers().then((response) => {
          this.agents = response.data.users;
        }),
      ];
      Promise.all(promises).then(() => {
        this.getViews();
      }).finally(() => {
        this.loader = false;
      });
    },
    close() {
      this.filterDialog = false;
      this.$nextTick(() => {
        this.editedItem.clients = [];
        this.editedItem.dossiers = [];
        this.editedItem.agents = [];
        this.editedIndex = -1;
      });
      this.save();
      this.$nextTick(() => {
        this.editedItem.clients = [];
        this.editedItem.dossiers = [];
        this.editedItem.agents = [];
        this.editedIndex = -1;
      });
    },
    closeViewDialog() {
      this.showAddViewDialog = false;
      this.$nextTick(() => {
        this.newViewName = "";
      });
    },
    closeExportDialog() {
      this.showExportDialog = false;
    },
    save() {
      this.loading = true;
      const months = this.editedItem.months?.sort((a, b) => a - b);
      const year = this.editedItem.year;
      const startMonth = `${year}-${months?.[0].padStart(2, "0")}-01`;
      const lastMonth = new Date(year, months?.[months?.length - 1], 0);
      const endMonth = `${year}-${months?.[months?.length - 1].padStart(
        2,
        "0"
      )}-${lastMonth.getDate()}`;
      const payload = {
        ...this.editedItem,
        year: this.editedItem.year,
        months: this.editedItem.months?.sort((a, b) => a - b),
        startMonth: startMonth,
        endMonth: endMonth,
        clients: this.editedItem.clients?.map((client) => client.id),
        dossiers: this.editedItem.dossiers?.map((dossier) => dossier.id),
        agents: this.editedItem.agents?.map((agent) => agent.id),
      };
      this.loader=true;
      getDynamicPivotTable(payload).then((response) => {
        this.tableHtml = response.data;
        this.loading = false;
        this.filterDialog = false;
        this.loader=false;
      });
      if (
        this.editedItem.year &&
        this.editedItem.months &&
        this.editedItem.months.length > 0
      ) {
        this.getClients();
      }
    },
    handleChipDelete(index, key) {
      this.editedItem[key].splice(index, 1);
      this.save();
    },
    handleReset() {
      this.editedItem.clients = [];
      this.editedItem.dossiers = [];
      this.editedItem.agents = [];
      this.save();
    },
    getViews() {
      getViewsApi().then((response) => {
        this.vues = response.data;
      });
    },
    addView() {
      if (!this.isValid) {
        this.$refs.form.validate();
        return;
      }
      this.loadingAdd = true;
      addViewApi({ name: this.newViewName, payload: this.editedItem }).then(
        () => {
          this.loadingAdd = false;
          this.closeViewDialog();
          this.$refs.form.reset();
          this.$swal.fire({ title: "Vue sauvegardée avec succès" });
          this.getViews();
        }
      );
    },
    getViewByName() {
      getViewByNameApi(this.vue).then((response) => {
        this.editedItem = Object.assign(JSON.parse(response.data.payload));
        this.diplayTable();
      });
    },
    handleExportClicked() {
      this.loadingExport = true;
      const months = this.editedItem.months?.sort((a, b) => a - b);
      const year = this.editedItem.year;
      const startMonth = `${year}-${months?.[0].padStart(2, "0")}-01`;
      const lastMonth = new Date(year, months?.[months?.length - 1], 0);
      const endMonth = `${year}-${months?.[months?.length - 1].padStart(
        2,
        "0"
      )}-${lastMonth.getDate()}`;
      const payload = {
        ...this.editedItem,
        year: this.editedItem.year,
        months: this.editedItem.months?.sort((a, b) => a - b),
        startMonth: startMonth,
        endMonth: endMonth,
        clients: this.editedItem.clients?.map((client) => client.id),
        dossiers: this.editedItem.dossiers?.map((dossier) => dossier.id),
        agents: this.editedItem.agents?.map((agent) => agent.id),
      };
      exportDynamicPivotTable(payload).then((response) => {
        this.loadingExport = false;
        this.closeExportDialog();
        let fileURL = window.URL.createObjectURL(new Blob([response.data]));
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "Tableau-croisé-dynamique.xlsx");
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    exportHTML() {
      this.closeExportDialog();
      const htmlContent = this.tableHtml;
      const blob = new Blob([htmlContent], {
        type: "text/html;charset=utf-8;",
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "Vue.html");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
};
</script>
<style scoped>
::v-deep .v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: inherit;
}
</style>
